import type {
    AssignRoleUserPayload,
    AssignRoleUserResponse,
} from '@/types/apps/assign-role-user.type';
import type { ApiResponse, PaginatedResult } from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';

type AssignRoleUserListResponse = ApiResponse<
    PaginatedResult<AssignRoleUserResponse>
>;

export class AssignRoleUserService implements Creatable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/admin/assign-role-user',
    };

    public create(
        payload: AssignRoleUserPayload
    ): Promise<ApiResponse<AssignRoleUserListResponse>> {
        return this.apiClient.postApi(this.endpoints.base(), payload);
    }
}
